module.exports = __webpack_public_path__ + "img/sei.055a558a.png";